import { Slice } from './types'

const getSlice = (state: any): Slice => {
  return state.customer.token
}

export const getToken = (state: any) => {
  return getSlice(state).payload?.token
}

export const getIsSuccess = (state: any) => {
  return getSlice(state).isSuccess
}

export const getError = (state: any): string | undefined => {
  const slice = getSlice(state)

  if (slice.isFailure) {
    return 'customer.account.login.error.incorrectSignIn'
  }
}
